import request from "@/axios/index";
// 新增——条款模板
export function saveformConfigLog(data) {
    return request({
        url: "/formConfig/save",
        method: "post",
        data
    })
}
// 修改/删除——条款模板
export function upadteformConfigLog(data) {
    return request({
        url: "/formConfig/update",
        method: "post",
        data
    })
}
// 查询——条款模板
export function formConfiglistLog(params) {
    return request({
      url: "/formConfig/list",
      method: "get",
      params
    })
}
// 查询字典
export function getzdlist(params) {
    return request({
      url: "/dataItem/dataItemByname",
      method: "get",
      params
    })
}
// 查询对应条款模板
export function getzdlistmoban(params) {
    return request({
      url: "/formConfig/getMType",
      method: "get",
      params
    })
}